var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCatchup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  enableBackground: "new 0 0 12 12",
  xmlSpace: "preserve"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 0h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0z",
  fill: "#e6e6e6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 1.8V.4L2.3 2.8 6 5.1V3.8c1.4 0 2.6 1.2 2.6 2.6C8.7 7.8 7.5 9 6 9c-.7 0-1.3-.3-1.8-.8s-.8-1.1-.8-1.8h-2c0 1.2.5 2.4 1.4 3.3.9.8 2 1.3 3.2 1.3 2.5 0 4.6-2.1 4.6-4.6 0-2.6-2-4.6-4.6-4.6z",
  fill: "#1B1E21"
})));
export default SvgIconCatchup;